// TODO: Get sentry and get correct one based on environment
// import "./../builder_configured_files/environment/prod/cgerrorloggingsentrymin";
// declare const SentryErrorLogging;
// let errorLoggingSettings = new SentryErrorLogging.SentryErrorLoggingServiceSettings();
// errorLoggingSettings.apiKey = "abc5a3bb019c48b2a35da39e4b7d904a";
// errorLoggingSettings.version = window["_version"];
// errorLoggingSettings.isProduction = true;
// const SentryLogger = new SentryErrorLogging.SentryErrorLoggingService(errorLoggingSettings);
// if (!MOCK)
// {
// 	SentryLogger.initialize().then(() => { console.log("Sentry initialized."); });
// }
var ErrorLogger = /** @class */ (function () {
    function ErrorLogger() {
    }
    ErrorLogger.sendError = function (arg0, reason) {
        if (MOCK) {
            console.error(arg0, reason);
            return;
        }
        // SentryLogger.sendError(arg0, reason);
    };
    ErrorLogger.setUserInfo = function (id, name) {
        if (MOCK) {
            return;
        }
        // SentryLogger.setUserInfo(id, name);
    };
    return ErrorLogger;
}());
export { ErrorLogger };
